import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Action, FrontRemoteRequest, RemoteResponse} from '../../domain/infra/remote';
import {Observable} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class FrontRemoteHttpService {
    private http: HttpClient;

    constructor(http: HttpClient) {
        this.http = http;
    }

    public sendRemoteAction(action: Action, stationRef: string, chargePointRef: string, plugRef: string, mediaCode: string) {
        return this.http.post<RemoteResponse>(
            `/front/remote/stations/${stationRef}/chargePoints/${chargePointRef}/plugs/${plugRef}/medias/${mediaCode}/${action}`,
            null);
    }

    public sendRemoteActionWithRequest(action: Action, request: FrontRemoteRequest) {
        return this.http.post<RemoteResponse>(`/front/remote/${action}`, request);
    }

    public remoteStopChargeRecord(chargeRecordId: string): Observable<RemoteResponse> {
        return this.http.post<RemoteResponse>(`/front/remote/chargeRecords/${chargeRecordId}/${Action.STOP}`, null);
    }

    public getRemoteByRemoteRef(action: Action, remoteId: string): Observable<RemoteResponse> {
        return this.http.get<RemoteResponse>(`/front/remote/${remoteId}/${action}`);
    }
}
